import { inject, NgModule } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';
import { AuthService } from './core/security/auth.service';


const routes: Routes = [
  { path: '', loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule) },
  {
    path: 'risk/claim-review',
    pathMatch: 'full',
    redirectTo: () => {
      const destination = '/accident-claim-form/list';
      return inject(AuthService).user$.value
        ? destination
        : inject(Router).createUrlTree(['/account/login'], { queryParams: { returnUrl: destination } });
    }
  },
  { path: 'account', loadChildren: () => import('./features/account/account.module').then(m => m.AccountModule) },
  { path: 'admin', loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule) },
  { path: 'claim-management', loadChildren: () => import('./features/claim-management/claim-management.module').then(m => m.ClaimManagementModule) },
  { path: 'accident-claim-form', loadChildren: () => import('./features/accident-claim-form/accident-claim-form.module').then(m => m.AccidentClaimFormModule) },
  { path: 'claim', loadChildren: () => import('./features/accident-claim-form/accident-claim-form.module').then(m => m.AccidentClaimFormModule) },
  { path: 'library', loadChildren: () => import('./features/library/library.module').then(m => m.LibraryModule) },
  { path: 'document-creation', loadChildren: () => import('./features/document-creation/document-creation.module').then(m => m.DocumentCreationModule) },
  { path: 'reports', loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule) },
  { path: 'general-contact-us', loadChildren: () => import('./features/general-contact-us/general-contact-us.module').then(m => m.GeneralContactUsModule) },
  { path: 'claim-form/risk', loadChildren: () => import('./features/accident-claim-form/accident-claim-form.module').then(m => m.AccidentClaimFormModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
